import { Button, Form, Input, Select } from 'antd';
import { SIGNUP } from 'api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import request from 'utils/request';
import Modal from '../../../components/Modal/index';

const { Option } = Select;

const Wrapper = styled.div`
  &&& {
    padding: 14px 20px 14px 20px;
    .ant-select-selector {
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      border-radius: 6px;
      .ant-select-selection-search {
        display: flex;
        align-items: center;
      }
    }
    .ant-checkbox-inner {
      border-radius: 4px;
    }
    .ant-radio-group.ant-radio-group-outline {
      width: 98%;
      padding-left: 1px;
    }
    .ant-radio-button-wrapper {
      border: 1px solid #e2e3e3;
      border-radius: 6px;
      &:before {
        display: none;
      }
    }
    .ant-radio-button-wrapper-checked {
      border-color: #4b97e9;
    }
    .ant-picker-input {
      input {
        font-style: italic;
      }
    }
  }
`;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};
/* eslint-enable no-template-curly-in-string */

function AddTenant({
  visible,
  setVisible,
  users,
  storages,
  getBoxes,
  boxes,
  loadingBox,
  postTransaction,
}) {
  const [id, setId] = useState(null);
  const [tab, setTab] = useState(null);
  const [storage, setStorage] = useState(null);
  const [boxId, setBoxId] = useState(null);
  const [date, setDate] = useState(null);
  const [dateValue, setDateValue] = useState(null);
  const [check, setCheck] = useState(null);
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleChange = (value) => {
    setId(value);
  };

  useEffect(() => {
    if (id) {
      getBoxes({
        transaction__client_id: id,
      });
    }
  }, [id]);

  const handleChangeStorage = (id) => {
    getBoxes({
      warehouse_id: id,
    });
    setStorage(id);
  };
  const onChangeCheck = (e) => {
    setCheck(e.target.checked);
    if (e.target.checked) {
      setTab('user');
      getBoxes({
        transaction__client_id: id,
      });
      setStorage(false);
    } else {
      setTab(null);
    }
  };

  const onFinish = async (values) => {
    const responce = await request(`v1${SIGNUP}`, {
      method: 'post',
      data: {
        ...values,
        token: window.location.hash.split('/')[2],
      },
    }).catch(e => {
      console.log(e);
    }).then(() => {
      setVisible(false);
    });
    console.log(responce);
  };

  const resetFields = () => {
    form.resetFields();
  };

  return (
    <Modal
      afterClose={resetFields}
      width={561}
      visible={visible}
      setVisible={setVisible}
    >
      <Wrapper>
        <div className="text-17 font-semibold text-black h-41 flex items-center">
          {t('addTenant')}
        </div>
        <Form
          form={form}
          {...layout}
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
        >
          <Form.Item
            name={['first_name']}
            label="First name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={['last_name']}
            label="Last name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={['email']}
            label="Email"
            rules={[
              {
                type: 'email',
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
            ]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="phone"
            label="Phone Number"
            rules={[
              {
                required: true,
                message: 'Please input your phone number!',
              },
            ]}
          >
            <Input
              // addonBefore={prefixSelector}
              style={{
                width: '100%',
              }}
            />
          </Form.Item>
          <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
            <Button type="primary" htmlType="submit">
              Create
            </Button>
            <Button onClick={resetFields}>Clear</Button>
          </Form.Item>
        </Form>
      </Wrapper>
    </Modal>
  );
}

AddTenant.propTypes = {};

export default AddTenant;
